import React, { useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
//UI
import {
  DangerButton,
  InfoButton,
  SuccessButton,
  WarningButton,
} from "../../../../ui/buttons/Button";
import { Input, SearchInput, Textarea } from "../../../../ui/inputs/Input";
import { Dimmer } from "../../../spinner";
import { Mensaje, MensajeSiNo } from "../../../mensajes2";
import axios from "axios";
import { validaSoloNumero } from "../../../../util/varios";
import CatalogoClasificadorDeBienes from "../../../../catalogos/catalogoClasificadorDeBienes";
import CatalogoCuentaContableBienes from "../../../../catalogos/catalogoCuentaContableBienes";
const op = require("../../../../modulos/datos");

export default function ClasificadorBienes({ show, setShow, setTabla }) {
  const token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtCodigo = useRef();
  const txtGrupo = useRef();
  const txtSubGrupo = useRef();
  const txtSeccion = useRef();
  const txtDescripcion = useRef();
  const txtCodCtaContable = useRef();
  const txtCtaContable = useRef();

  const [operacion, setOperacion] = useState(0);
  const [txtOperacion, setTxtOperacion] = useState("");
  const [activate, setActivate] = useState(false);
  const [visibleButton, setVisibleButton] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [mostrarCatalogo, setMostrarCatalogo] = useState(false);
  const [mostrarCatalogoCuenta, setMostrarCatalogoCuenta] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const blanquear = () => {
    txtCodigo.current.value = "";
    txtGrupo.current.value = "";
    txtSubGrupo.current.value = "";
    txtSeccion.current.value = "";
    txtDescripcion.current.value = "";
    txtCodCtaContable.current.value = "";
    txtCtaContable.current.value = "";

    setOperacion(0);
    setTxtOperacion("");
    setVisibleButton(true);
    setDisabled(true);
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setMensajesino({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });

    setActivate(false);
  };

  const seleccionarCuenta = async (id) => {
    const endpoint = `${op.conexion}/api/bienes/clasificador/seleccionar_ctaconta?&idcuentacontable=${id}&idefiscal=${idefiscal}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtCtaContable.current.value = data.codigocuenta.trim();
          } else {
            txtCodCtaContable.current.value = "";
            txtCtaContable.current.value = "";
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const seleccionacuentacontablexclasificabienes = async (id) => {
    const campos = "*";
    const nomtab = "cuentacontablexclasificabienes";
    const nomid = "idclasificabienes";
    const nomid2 = "idefiscal";
    const id2 = idefiscal;
    const endpoint = `${op.conexion}/api/consulta/modeli2?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            const data = response.data[0];

            if (data.idcuentacontable) {
              txtCodCtaContable.current.value = data.idcuentacontable.trim();
              await seleccionarCuenta(data.idcuentacontable);
            } else {
              setActivate(false);
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto: "el clasificador no tiene una cuenta contable asociada.",
                icono: "informacion",
              });
            }
          } else {
            txtCodCtaContable.current.value = "";
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "el clasificador no tiene una cuenta contable asociada.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionaclasificador = async () => {
    const campos = "*";
    const id = txtCodigo.current.value;
    const nomtab = "clasificabienes";
    const nomid = "idclasificabienes";
    const endpoint = `${op.conexion}/api/consulta/modeli?&campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(async function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            const data = response.data;
            txtGrupo.current.value = data.grupo.trim();
            txtSubGrupo.current.value = data.subgrupo.trim();
            txtSeccion.current.value = data.seccion.trim();
            txtDescripcion.current.value = data.descripcion.trim();
            setDisabled(operacion !== 2);
            await seleccionacuentacontablexclasificabienes(id);
          } else {
            txtGrupo.current.value = "";
            txtSubGrupo.current.value = "";
            txtSeccion.current.value = "";
            txtDescripcion.current.value = "";
            txtCodCtaContable.current.value = "";
            txtCtaContable.current.value = "";
            setActivate(false);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "no existe un clasificador con ese codigo.",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const procesarRegistro = async (body) => {
    setActivate(true);
    const endpoint = `${op.conexion}/api/bienes/clasificador/actualizar`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
                    let msm = "";
          if (operacion === 1) {
            msm =
              "registro " +
              response.data.clasificabienes_act +
              " creado correctamente";
          } else if (operacion === 2) {
            msm =
              "registro " +
              response.data.clasificabienes_act +
              " modificado correctamente";
          } else if (operacion === 3) {
            msm =
              "registro " +
              response.data.clasificabienes_act +
              " eliminado correctamente";
          }

          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: msm,
            icono: "exito",
          });
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response) {
          mensaje = error?.response?.data?.message;
        } else {
          mensaje = error.toString();
        }

        if (
          mensaje ===
          `duplicate key value violates unique constraint "clasificabienes_pkey"`
        ) {
          mensaje = "Ya Existe un clasificador con ese codigo.";
        }

        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
      })
      .finally(() => setActivate(false));
  };

  const onChangeValidar = async () => {
    let sigue = true;

    if (operacion !== 1 && txtCodigo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar el codigo.`,
        icono: "informacion",
      });
      sigue = false;
      txtCodigo.current.focus();
    } else if (txtGrupo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar el grupo.`,
        icono: "informacion",
      });
      sigue = false;
      txtGrupo.current.focus();
    } else if (txtSubGrupo.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar el subgrupo.`,
        icono: "informacion",
      });
      sigue = false;
      txtSubGrupo.current.focus();
    } else if (txtSeccion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la seccion.`,
        icono: "informacion",
      });
      sigue = false;
      txtSeccion.current.focus();
    } else if (txtDescripcion.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: `debe ingresar la Descripcion.`,
        icono: "informacion",
      });
      sigue = false;
      txtDescripcion.current.focus();
    }

    if (sigue) {
      const datos = {
        operacion: operacion,
        codigo:
          txtCodigo.current.value === "" ? "0" : txtCodigo.current.value.trim(),
        grupo: txtGrupo.current.value.trim().toUpperCase(),
        subgrupo: txtSubGrupo.current.value.trim().toUpperCase(),
        seccion: txtSeccion.current.value.trim().toUpperCase(),
        descripcion: txtDescripcion.current.value.trim().toUpperCase(),
        contable:
          txtCodCtaContable.current.value === ""
            ? 0
            : txtCodCtaContable.current.value,
        idfiscal: idefiscal,
      };

      await procesarRegistro({
        datos: datos,
      });
    }
  };

  const salir = () => {
    setShow(false);
    setTabla(0);
  };

  const onChange = (e) => {
    if (e.target.value !== "") {
      e.target.value = e.target.value.toUpperCase();
    }
  };

  const onNextChange = (e) => {
    if (e.which === 13) {
      if (e.target.name === "codigo") {
        txtGrupo.current.focus();
      } else if (e.target.name === "grupo") {
        txtSubGrupo.current.focus();
      } else if (e.target.name === "subgrupo") {
        txtSeccion.current.focus();
      } else if (e.target.name === "seccion") {
        txtDescripcion.current.focus();
      } else if (e.target.name === "descripcion") {
        btnAcepta.current.focus();
      }
    }
  };

  const validarCodigo = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodigo.current.blur();
        seleccionaclasificador();
      } else {
        txtGrupo.current.value = "";
        txtSubGrupo.current.value = "";
        txtSeccion.current.value = "";
        txtDescripcion.current.value = "";
        txtCodCtaContable.current.value = "";
        txtCtaContable.current.value = "";
      }
    }
  };

  const validarCodigoCta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        txtCodCtaContable.current.blur();
        seleccionarCuenta(event.target.value);
      } else {
        txtCtaContable.current.value = "";
      }
    }
  };

  const onHideCatalogo = (value = false) => {
    setMostrarCatalogo(false);
    if (value) {
      txtCodigo.current.value = value.idclasificabienes;
      seleccionaclasificador();
    }
  };

  const onHideCuenta = (value) => {
    setMostrarCatalogoCuenta(false);
    if (value) {
      txtCodCtaContable.current.value = value.idcuentacontable;
      seleccionarCuenta(value.idcuentacontable);
    }
  };

  const onClickButton = async (value) => {
    if (value === 1) {
      setOperacion(1);
      setTxtOperacion("[Incluyendo]");
      setVisibleButton(false);
      setDisabled(false);
      setTimeout(() => {
        txtGrupo.current.focus();
      }, 200);
    } else if (value === 2) {
      setOperacion(2);
      setTxtOperacion("[Editando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 3) {
      setOperacion(3);
      setTxtOperacion("[Eliminando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 4) {
      setOperacion(4);
      setTxtOperacion("[Consultando]");
      setVisibleButton(false);
      setTimeout(() => {
        txtCodigo.current.focus();
      }, 200);
    } else if (value === 5) {
      setVisibleButton(false);
      await onChangeValidar();
    } else if (value === 6) {
      blanquear();
    }
  };

  return (
    <Modal size="lg" show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top azulGradiant">
        <h3 className="fw-bold m-0">Clasificador de Bienes {txtOperacion}</h3>
        <a type="button" className="fw-bold text-light fs-6" onClick={salir}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-2">
        <div className="col-4 m-0 mb-2 p-0">
          <SearchInput
            ref={txtCodigo}
            disabled={operacion < 2}
            onKeyUp={validarCodigo}
            onBlur={validarCodigo}
            label="Código:"
            name="codigo"
            onClickButton={() => setMostrarCatalogo(true)}
            disabledButton={operacion < 2}
          />
        </div>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <div className="col-4 m-0 mb-2 p-0">
            <Input
              ref={txtGrupo}
              disabled={disabled}
              onChange={onChange}
              onKeyUp={onNextChange}
              maxLength={2}
              label="Grupo:"
              name="grupo"
            />
          </div>
          <div className="col-4 m-0 mb-2 p-0 pl-2">
            <Input
              ref={txtSubGrupo}
              disabled={disabled}
              onChange={onChange}
              onKeyUp={onNextChange}
              maxLength={2}
              label="Subgrupo:"
              name="subgrupo"
            />
          </div>
          <div className="col-4 m-0 mb-2 p-0 pl-2">
            <Input
              ref={txtSeccion}
              disabled={disabled}
              onChange={onChange}
              onKeyUp={onNextChange}
              maxLength={2}
              label="Sección:"
              name="seccion"
            />
          </div>
          <div className="col-12 m-0 p-0">
            <Textarea
              ref={txtDescripcion}
              disabled={disabled}
              onChange={onChange}
              onKeyUp={onNextChange}
              label="Descripción:"
              name="descripcion"
              style={{ height: 70 }}
            />
          </div>
        </fieldset>
        <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
          <legend className="float-none w-auto m-0">Cuenta Contable</legend>
          <div className="col-3 m-0 p-0">
            <SearchInput
              disabled={disabled}
              ref={txtCodCtaContable}
              onKeyUp={validarCodigoCta}
              onBlur={validarCodigoCta}
              onClickButton={() => setMostrarCatalogoCuenta(true)}
              disabledButton={operacion !== 1 && operacion !== 2}
            />
          </div>
          <div className="col m-0 p-0 pl-2">
            <Input disabled ref={txtCtaContable} />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        {visibleButton ? (
          <div className="col-12 d-flex m-auto justify-content-between">
            <SuccessButton onClick={() => onClickButton(1)} icon="fas fa-plus">
              Incluir
            </SuccessButton>
            <InfoButton onClick={() => onClickButton(4)} icon="fas fa-search">
              Consultar
            </InfoButton>
            <WarningButton onClick={() => onClickButton(2)} icon="fas fa-edit">
              Editar
            </WarningButton>
            <DangerButton onClick={() => onClickButton(3)} icon="fas fa-trash">
              Eliminar
            </DangerButton>
          </div>
        ) : (
          <div className="col-12 d-flex m-auto justify-content-end">
            <div className="m-1 p-0">
              <SuccessButton
                disabled={operacion === 4}
                ref={btnAcepta}
                onClick={() => onClickButton(5)}
              >
                Aceptar
              </SuccessButton>
            </div>
            <div className="m-1 p-0">
              <DangerButton ref={btnCancela} onClick={() => onClickButton(6)}>
                Cancelar
              </DangerButton>
            </div>
          </div>
        )}
      </Modal.Footer>
      <Dimmer active={activate} />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <CatalogoClasificadorDeBienes
        show={mostrarCatalogo}
        onHide={onHideCatalogo}
      />
      <CatalogoCuentaContableBienes
        show={mostrarCatalogoCuenta}
        desde={2}
        onHide={onHideCuenta}
      />
    </Modal>
  );
}
